<div class="main-container" v-if="success">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Account Setup</h1>
        <p class="light">In order to get started you’ll need to create a new password so we can setup your account.</p>
        <p class="light">Your password should be made up of uppercase, lowercase letters and numbers (no symbols please).</p>
        <br>

        <app-form-error></app-form-error>

        <form class="login">
          <div class="field">
            <div class="left floated label">New Password</div>
            <app-text-input
              icon="lock"
              type="password"
              v-model="password"
              placeholder="Enter your new password"
              :error="validation('password')"
              autocomplete="new-password"
            />
          </div>

          <div class="field">
            <div class="left floated label">Confirm New Password</div>
            <app-text-input
              icon="lock"
              type="password"
              v-model="password_confirmation"
              placeholder="Confirm your new password"
              :error="validation('password_confirmation')"
              autocomplete="new-password"
            />
          </div>

          <div class="field">
            <a class="ui fluid primary button" v-on:click="finish">CREATE ACCOUNT</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
